export default __webpack_public_path__ + "static/SmartViewPrint3-1a3f21bd3752c2f2c5351bd66fd3ac8e.webp";